export default {
  path: '/pos-orders',
  component: () => import('../../views/posOrders/PosOrders-router.vue'),
  children: [
    {
      path: '',
      name: 'PosOrders',
      component: () => import('../../views/posOrders/pages/PosOrders.vue'),
      meta: {
        name: 'ออเดอร์',
        icon: '/icons/pos.svg',
        auth: true
      }
    },
    {
      path: 'pos-print-refund/:id',
      name: 'PosPrintRefund',
      component: () => import('../../views/posOrders/pages/PosPrintRefund.vue'),
      meta: {
        name: 'ออเดอร์',
        icon: '/icons/pos.svg',
        layout: 'blank'
      }
    },
    {
      path: 'pos-medicine-label/:id',
      name: 'PosMedicineLabel',
      component: () => import('../../views/posOrders/pages/PosMedicineLabel.vue'),
      meta: {
        name: 'ออเดอร์',
        icon: '/icons/pos.svg',
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'pos-order-detail/:id',
      name: 'PosOrderDetail',
      component: () => import('../../views/posOrders/pages/PosOrderDetail.vue'),
      meta: {
        name: 'navigationDrawer.posOrders',
        icon: '/icons/pos.svg',
        auth: true
      }
    },
    {
      path: 'print-medicine-labels/:id',
      name: 'PrintMedicineLabels',
      component: () => import('../../views/posOrders/pages/PrintMedicineLabels.vue'),
      meta: {
        name: 'ออเดอร์',
        icon: '/icons/pos.svg',
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'pos-order-cancel/:id',
      name: 'PosOrderCancel',
      component: () => import('../../views/posOrders/pages/PosOrderCancel.vue'),
      meta: {
        name: 'navigationDrawer.posOrders',
        icon: '/icons/pos.svg',
        auth: true
      }
    }
  ]
}
